module.exports = __webpack_public_path__ + "img/noaa-login-banner.70fd8ea9.png";